import React from "react";
import EditInvoice from "pages/Administration/EditInvoice";
import useQueryParams from "customHooks/useQueryParams";

export default function UpdateInvoice() {
  const { idCliente } = useQueryParams();

  return <EditInvoice redirectPath="documentos" idCustomer={+idCliente} />;
}
